<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>About Us</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>About Us</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start About Area -->
<section class="about-area ptb-110">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-content">
                    <span>About <strong>SolarCiti</strong></span>
                    <h2>Powering a smarter and more sustainable future with solar energy.</h2>
                    <p>
                        <strong>SolarCiti</strong> provides reliable and customized solar energy solutions for
                        residential, commercial, and industrial requirements. Our goal is to
                        make clean energy more accessible while helping customers reduce
                        electricity costs and improve energy efficiency.
                    </p>
                    <p>
                        From consultation and rooftop site inspection to system design,
                        installation, commissioning, and post-installation support, we provide
                        end-to-end solar solutions tailored to each customer's energy needs.
                    </p>
                    <p>
                        With a focus on quality, efficiency, and dependable service, <strong>SolarCiti</strong>
                        helps homes and businesses make a confident transition towards clean,
                        sustainable, and cost-effective solar power.
                    </p>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="about-image">
                    <img src="assets/image/about-1.png" alt="image">
                </div>
            </div>
        </div>

        <div class="about-inner-area">
            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="about-text">
                        <h3>Our Journey</h3>
                        <p>
                            <strong>SolarCiti</strong> is focused on making reliable and efficient solar energy
                            solutions more accessible to homes, businesses, and industries.
                            We are committed to building long-term value through clean energy.
                        </p>

                        <i class="flaticon-house"></i>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="about-text">
                        <h3>Our Mission</h3>
                        <p>
                            Our mission is to help customers reduce energy costs and adopt
                            sustainable power through customized solar systems, professional
                            installation, and dependable after-sales support.
                        </p>

                        <i class="flaticon-insurance"></i>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                    <div class="about-text">
                        <h3>Who We Are</h3>
                        <p>
                            <strong>SolarCiti</strong> is a solar energy solutions provider offering residential,
                            commercial, and industrial solar systems along with consultation,
                            installation, maintenance, and ongoing support.
                        </p>

                        <i class="flaticon-box"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End About Area -->

<app-funfact></app-funfact>

<!-- Start Features Area -->
<section class="features-area ptb-110 bg-f7f9fc">
    <div class="container">

        <div class="overview-box">
            <div class="image wow zoomIn" data-wow-delay="1s">
                <img src="assets/image/about.png" alt="SOLARCITI Solar Solutions">
            </div>

            <div class="content">
                <h3>Smart solar solutions designed around your energy needs.</h3>
                <p>
                    At <strong>SolarCiti</strong>, we believe solar energy should be simple, reliable,
                    and accessible. We provide customized solar solutions that help
                    homes, businesses, and industries reduce electricity costs while
                    making a positive impact on the environment.
                </p>

                <ul class="features-list">
                    <li>
                        <span>
                            <i class='bx bx-check-double'></i>
                            Customized Solar System Design
                        </span>
                    </li>
                    <li>
                        <span>
                            <i class='bx bx-check-double'></i>
                            Efficient & Reliable Solar Solutions
                        </span>
                    </li>
                    <li>
                        <span>
                            <i class='bx bx-check-double'></i>
                            Professional Installation
                        </span>
                    </li>
                    <li>
                        <span>
                            <i class='bx bx-check-double'></i>
                            Focus on Long-Term Energy Savings
                        </span>
                    </li>
                </ul>
            </div>
        </div>


        <div class="overview-box">

            <div class="content">
                <h3>Complete solar support from consultation to long-term care.</h3>

                <p>
                    Our approach goes beyond installation. From rooftop inspection
                    and system sizing to installation, commissioning, net-metering
                    support, and maintenance, <strong>SolarCiti</strong> provides end-to-end support
                    throughout your solar journey.
                </p>

                <ul class="features-list">
                    <li>
                        <span>
                            <i class='bx bx-check-double'></i>
                            Expert Consultation & Site Assessment
                        </span>
                    </li>
                    <li>
                        <span>
                            <i class='bx bx-check-double'></i>
                            Installation & Commissioning
                        </span>
                    </li>
                    <li>
                        <span>
                            <i class='bx bx-check-double'></i>
                            Subsidy & Net-Metering Assistance
                        </span>
                    </li>
                    <li>
                        <span>
                            <i class='bx bx-check-double'></i>
                            Maintenance & After-Sales Support
                        </span>
                    </li>
                </ul>
            </div>

            <div class="image wow zoomIn" data-wow-delay="1s">
                <img src="assets/image/banner2.png" alt="SOLARCITI Solar Installation">
            </div>

        </div>

    </div>

    <div class="rectangle-shape1">
        <img src="assets/img/rectangle-shape1.png" alt="image">
    </div>

    <div class="rectangle-shape2">
        <img src="assets/img/rectangle-shape2.png" alt="image">
    </div>
</section>
<!-- End Features Area -->


<!-- Start Team Area -->
<section class="team-area bg-fafafa ptb-110 pb-0">
    <div class="container">
        <div class="section-title">
            <h2>Our Work</h2>
            <p>
                Explore some of the work we have delivered with quality,
                innovation, and a commitment to creating impactful solutions.
            </p>
        </div>

        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/image/user.jpeg" alt="Residential Solar Installation">
                    </div>

                    <!-- <div class="content">
                        <h3>Residential Solar</h3>
                        <span>Rooftop Solar Installation</span>
                    </div> -->
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/image/work1.jpeg" alt="Commercial Solar Installation">
                    </div>

                    <!-- <div class="content">
                        <h3>Commercial Solar</h3>
                        <span>Commercial Solar Solutions</span>
                    </div> -->
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/image/work2.jpeg" alt="Industrial Solar Installation">
                    </div>

                    <!-- <div class="content">
                        <h3>Industrial Solar</h3>
                        <span>Large-Scale Solar Projects</span>
                    </div> -->
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-team-box">
                    <div class="image">
                        <img src="assets/image/work3.jpeg" alt="Solar Project">
                    </div>

                    <!-- <div class="content">
                        <h3>Solar Projects</h3>
                        <span>Clean Energy Solutions</span>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Team Area -->

<app-feedback></app-feedback>

<app-faq></app-faq>